import { render } from "./SearchPromotionPage.vue?vue&type=template&id=7f2b3db4"
import script from "./SearchPromotionPage.vue?vue&type=script&lang=js"
export * from "./SearchPromotionPage.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__